import { Swiper as SwiperCore } from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay, Grid } from 'swiper/modules';

import './Swiper.scss';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, Grid]);

export { Swiper } from 'swiper/react';
